import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => (
  <footer className="hidden md:block bg-gray-100 border-t border-gray-300 py-3">
    <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-3">
      <div className="flex items-center gap-2">
        <div className="w-6 h-6 bg-blue-600 rounded flex items-center justify-center">
          <img
            src="/icon-192x192.png"
            alt="Footer Icon"
            className="w-6 h-6 object-contain"
          />
        </div>
        <span className="text-gray-500 text-xs">
          © {new Date().getFullYear()} TyreLink. All rights reserved.
        </span>
      </div>
      <nav className="flex flex-wrap gap-3 text-xs">
        <Link
          to="/legal/terms"
          className="text-gray-500 hover:text-blue-600 transition-colors"
        >
          Terms
        </Link>
        <Link
          to="/legal/privacy"
          className="text-gray-500 hover:text-blue-600 transition-colors"
        >
          Privacy Policy
        </Link>
        <Link
          to="/legal/popia"
          className="text-gray-500 hover:text-blue-600 transition-colors"
        >
          POPIA Notice
        </Link>
        <Link
          to="/legal/contact"
          className="text-gray-500 hover:text-blue-600 transition-colors"
        >
          Contact
        </Link>
        <a
          href="https://help.tyrelink.app"
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-500 hover:text-blue-600 transition-colors"
        >
          Help Centre / FAQ
        </a>
      </nav>
    </div>
  </footer>
);

export default Footer;